import _ from 'underscore';
import { useEffect, useState } from 'react';
import { getAutoGoalRecommendations } from './goal-recommendations';

export const useRecommendation = ({
  serverContext,
  activity,
}) => {
  const [recommendation, setRecommendation] = useState([]);
  const { Token } = serverContext;
  const { Id: aid, AdvertiserCustomerID: cid } = serverContext.CurrentAccount;

  useEffect(() => {
    getAutoGoalRecommendations(cid, aid, Token).then((result) => {
      activity.trace(`Load Recommendation : ${JSON.stringify(result)}`);
      const finalResult = _.get(result, 'value', []);
      setRecommendation(finalResult);
    }).catch((error) => {
      activity.error(`Load Recommendation Failed: ${JSON.stringify(error)}`);
    });
  }, [Token, activity, aid, cid]);

  return [recommendation];
};
